module.exports = "/assets/data/33a4c40c0fd399c118d5ed893a60e8bf-YO32.data.json";